import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefautProduitAspectDeballageStep from './DefautProduitAspectDeballageStep';

class DefautProduitAspectDeballageStepContainer extends React.Component {


    render() {
        return (
            <DefautProduitAspectDeballageStep {...this.props}/>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let colisLogistiques = state.colisLogistique.colisLogistiques.items;

    return {
        colisLogistiques: colisLogistiques
    };
};

//const mapDispatchToProps = (dispatch) => ({
//});

DefautProduitAspectDeballageStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(DefautProduitAspectDeballageStepContainer);